import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VTextField,_vm._b({attrs:{"outlined":"","label":_vm.$t('Maximum uses per customer'),"hide-details":"auto","type":"number"},model:{value:(_vm.max_customer_uses),callback:function ($$v) {_vm.max_customer_uses=$$v},expression:"max_customer_uses"}},'v-text-field',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }